/* src/interviews/cards/FillInterviewForm/styles.js */

export default theme => {
  const { unit } = theme.spacing;

  return {
    card: {
      height: unit * 100,
      overflow: 'auto',
      position: 'relative',
    },
    expand: {
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
      marginLeft: 'auto',
    },
    expandOpen: {
      transform: 'rotate(180deg)',
    },
    moreInfo: {
      display: 'flex',
      flexGrow: 1,
      padding: unit,
    },
    appliedCourses: {
      padding: unit * 3,
    },
    universityContainer: {
      marginBottom: unit * 2,
    },
    university: {
      textDecoration: 'underline',
    },
    courses: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
    text: {
      marginRight: unit * 2,
    },
    formContainer: {
      padding: unit * 3,
      paddingBottom: 0,
      height: unit * 49,
      backgroundColor: theme.palette.background.default,
      overflow: 'auto',
    },
    questionContainer: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: unit * 3,
    },
    icon: {
      marginRight: unit,
    },
    button: {
      marginLeft: unit,
    },
    footer: {
      padding: unit * 3,
      height: unit * 17,
      paddingTop: unit,
      display: 'flex',
      flex: 1,
      alignItems: 'flex-end',
      justifyContent: 'space-between',
      flexDirection: 'column',
    },
    save: {
      marginBottom: unit,
    },
    ratingContainer: {
      display: 'flex',
      flex: 1,
      justifyContent: 'space-around',
      marginLeft: -unit * 3,
      paddingBottom: unit * 3,
    },
    formControl: {
      flex: 1,
      marginLeft: unit * 3,
    },
  };
};



// WEBPACK FOOTER //
// ./src/modules/interviews/cards/FillInterviewForm/styles.js